__turbopack_context__.v({
  "bold-price": "style-module-scss-module__4SlYNa__bold-price",
  "card-wrapper": "style-module-scss-module__4SlYNa__card-wrapper",
  "heading": "style-module-scss-module__4SlYNa__heading",
  "minimal-listings": "style-module-scss-module__4SlYNa__minimal-listings",
  "mobile-carousel": "style-module-scss-module__4SlYNa__mobile-carousel",
  "price-range": "style-module-scss-module__4SlYNa__price-range",
  "similar-listings": "style-module-scss-module__4SlYNa__similar-listings",
});
